import React from "react";

import { TabDeletePage } from "../../_shared/pages/TabDeletePage";

export const AgileTabDeletePage: React.FC = () => {
  return (
    <TabDeletePage
      applicationType="agile"
      title="Sorry to see you go! Your AgilePolly tab will be removed."
    />
  );
};
